<template>
  <div>
    <div v-if="isLoading">
      <OtherLoading />
    </div>
    <div v-else>
      <HeaderPanel
        title="ค้นหารายการมัดจำ"
        :filter="filter"
        @search="handleSearch"
        @clear="clearFilter"
      >
        <b-button
          variant="filter"
          @click="$router.push('/deposit/create')"
          class="btn-filter mr-2"
        >
          <font-awesome-icon icon="plus" class="pointer icon" />
          <span class="d-none d-md-block ml-2">สร้าง</span>
        </b-button>
        <template v-slot:filter-option>
          <b-col>
            <InputText
              v-model="filter.invoice_no"
              textFloat="Doc Number / เลขที่เอกสาร"
              placeholder="Doc Number / เลขที่เอกสาร"
              type="text"
              name="doc_number"
              @onDataChange="handleSearch"
              class="mb-2"
            />
          </b-col>
          <b-col>
            <InputText
              v-model="filter.search"
              textFloat="Customer name / ชื่อลูกค้า"
              placeholder="Customer name / ชื่อลูกค้า"
              type="text"
              name="inventory_search"
              @onDataChange="handleSearch"
              class="mb-2"
            />
          </b-col>
        </template>
      </HeaderPanel>
      <div class="bg-white border-red mt-3">
        <b-row>
          <b-col>
            <b-table
              responsive
              striped
              hover
              :fields="fields"
              :items="items"
              :busy="isBusy"
              show-empty
              empty-text="No matching records found"
              class="table-main"
              :no-border-collapse="false"
            >
              <template v-slot:cell(invoiceNo)="data">
                <router-link :to="'/deposit/detail/' + data.item.id">
                  <u>{{ data.item.invoiceNo }}</u>
                </router-link>
              </template>
              <template v-slot:cell(createdTime)="data">
                <div>
                  {{
                    $moment(data.item.createdTime).format("DD/MM/YYYY HH:mm:ss")
                  }}
                </div>
              </template>
              <template v-slot:cell(pickupDate)="data">
                <div>
                  {{
                    $moment(data.item.pickupDate).format("DD/MM/YYYY HH:mm:ss")
                  }}
                </div>
              </template>
              <template v-slot:cell(depositStatusName)="data">
                <div v-if="data.item.depositStatus == 1" class="text-warning">
                  {{ data.item.depositStatusName }}
                </div>
                <div v-else class="text-error">
                  {{ data.item.depositStatusName }}
                </div>
              </template>
              <template v-slot:cell(memberId)="data">
                <div class="text-underline">
                  <div>{{ data.item.memberId }}</div>
                  <div>
                    {{ data.item.firstNameTh }} {{ data.item.lastNameTh }}
                  </div>
                  <div>
                    {{ data.item.telephone }}
                  </div>
                </div>
              </template>

              <template v-slot:table-busy>
                <div class="text-center text-black my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="ml-2">Loading...</strong>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <Pagination
          @handleChangeTake="handleChangeTake"
          :pageOptions="pageOptions"
          :filter="filter"
          :rows="rows"
          @pagination="pagination"
        />
      </div>
    </div>
    <ModalTransfer
      ref="modalTransfer"
      @reloadDataTable="getList"
      :branchId="branchId"
      @reloadOtherBranch="reloadOtherBranch"
    />
    <ModalManage
      ref="modalManage"
      @reloadDataTable="getList"
      :branchId="branchId"
    />
    <ModalOtherBranch
      ref="modalOtherBranch"
      @reloadDataTable="getList"
      :branchId="branchId"
      @handleTransfer="handleTransfer"
    />
  </div>
</template>

<script>
import OtherLoading from "@/components/loading/OtherLoading";
import HeaderPanel from "@/components/HeaderPanel";
import Pagination from "@/components/Pagination";
import InputText from "@/components/inputs/InputText";
import ModalManage from "@/components/inventory/ModalManage";
import ModalOtherBranch from "@/components/inventory/ModalOtherBranch";
import ModalTransfer from "@/components/inventory/ModalTransfer";
import { mapGetters } from "vuex";

export default {
  components: {
    OtherLoading,
    Pagination,
    HeaderPanel,
    InputText,
    ModalManage,
    ModalOtherBranch,
    ModalTransfer,
  },
  name: "Inventory",
  data() {
    return {
      fields: [
        {
          key: "invoiceNo",
          label: "Doc Number",
          thStyle: { width: "15%" },
        },
        {
          key: "depositTypeName",
          label: "ประเภท",
        },

        {
          key: "name",
          label: "สินค้า",
          thStyle: { width: "20%" },
        },
        {
          key: "memberId",
          label: "ลูกค้า",
          class: "text-left pointer",
          thStyle: { width: "15%" },
        },
        {
          key: "pickupDate",
          label: "กำหนดรับ",
        },
        {
          key: "depositStatusName",
          label: "สถานะเอกสาร",
        },
        {
          key: "createdTime",
          label: "วันที่จอง",
          tdClass: "text-center",
        },
      ],
      items: [],
      isBusy: false,
      isLoadingData: false,
      checkAll: false,
      selectAllCb: false,
      rows: 0,
      showing: 1,
      showingTo: 10,
      checkboxActive: false,
      checkboxInactive: false,
      filter: {
        branch_id: this.branchId,
        search: "",
        invoice_no: "",
        page: 1,
        take: 10,
      },
      pageOptions: [
        { value: 5, text: "5 / page" },
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      selected: 0,
      isLoading: true,
      styleDatetime: {
        width: "100%",
        border: "none",
      },
    };
  },
  computed: {
    ...mapGetters({
      branchId: "getBranchId",
    }),
  },
  created: async function () {
    this.filter.branch_id = this.branchId;
    await this.getList();
  },
  methods: {
    getList: async function () {
      //         {
      //     "invoiceNo": "DEP-ZEN1604680003",
      //     "depositType": 2,
      //     "depositStatus": 0,
      //     "createdTime": "0001-01-01T00:00:00",
      //     "pickupDate": "2025-04-11T01:40:47",
      //     "memberId": "1230000504363",
      //     "firstNameTh": "Chaiyawat",
      //     "lastNameTh": "Chongsuwanit",
      //     "firstNameEn": "",
      //     "lastNameEn": "",
      //     "name": "ทองทดสอบเท่าไหร่ไม่รู้"
      // }
      this.isBusy = true;

      this.isLoadingData = true;
      await this.axios(
        `${this.$baseUrl}/deposit/list?search=${this.filter.search}&BranchId=${this.branchId}&InvoiceNumber=${this.filter.invoice_no}&page=${this.filter.page}&pageSize=${this.filter.take}`
      ).then((data) => {
        this.isLoading = false;
        if (data.result == 1) {
          this.items = data.detail.transactionList;
          this.rows = data.detail.total;
          this.isLoadingData = false;
        }
      });

      this.isBusy = false;
    },
    handleSearch(value) {
      this.pagination(1);
    },
    pagination(page) {
      this.filter.page = page;
      this.$emit("filterPage", this.filter);
      this.getList();
    },
    handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;
      this.$emit("filterPage", this.filter);
      this.getList();
    },
    clearFilter() {
      this.filter = {
        search: "",
        invoice_no: "",
        page: 1,
        take: 10,
        branch_id: this.branchId,
      };
      this.getList();
    },
    handleTransfer(item) {
      this.$refs.modalTransfer.show(item, "otherBranch");
    },
    reloadOtherBranch() {
      this.$refs.modalOtherBranch.getOtherBranchInventory();
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.time {
  color: #afafaf;
}
.line-clamp2 {
  word-break: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.badge {
  font-size: 85%;
  background-color: var(--secondary-color);
  color: var(--primary-color);
  max-width: max-content;
  font-weight: 100;
}
.badge-container {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.info {
  margin: 0 5px;
  font-size: 24px;
  color: #000 !important;
}

::v-deep .table-main {
  table {
    min-width: max-content;
  }
}
</style>
